module.exports = __webpack_public_path__ + "img/4.f2346f27.svg";